var exports = {
  "kL": "container__Vj-8D0",
  "DG": "createForm__fte8bb",
  "JO": "createTitle__9HVYbf",
  "mU": "loadingSkeleton__Q_w3yN",
  "b2": "statusList__X6LLGY",
};

module.exports = exports;
